// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/** The backend API version this bundle is built against. */
export const API_VERSION = '2026-10-24';
